module.exports = __webpack_public_path__ + "cb07194a3ed3eee782a1eb5a1aab9c89.jpg";